import React from 'react';

export type PartnerDetailTab =
  | 'overview'
  | 'compliance'
  | 'users'
  | 'fees'
  | 'portal'
  | 'operations';

export interface PartnerDetailTabDef {
  id: PartnerDetailTab;
  label: string;
  channelPartnerOnly?: boolean;
}

export const PARTNER_DETAIL_TABS: PartnerDetailTabDef[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'compliance', label: 'Compliance' },
  { id: 'users', label: 'Attributed users', channelPartnerOnly: true },
  { id: 'fees', label: 'Fees & rails' },
  { id: 'portal', label: 'Portal & team' },
  { id: 'operations', label: 'Operations', channelPartnerOnly: true },
];

interface PartnerDetailTabNavProps {
  activeTab: PartnerDetailTab;
  onTabChange: (tab: PartnerDetailTab) => void;
  showChannelPartnerTabs: boolean;
}

export const PartnerDetailTabNav: React.FC<PartnerDetailTabNavProps> = ({
  activeTab,
  onTabChange,
  showChannelPartnerTabs,
}) => {
  const tabs = PARTNER_DETAIL_TABS.filter(
    (t) => !t.channelPartnerOnly || showChannelPartnerTabs,
  );

  return (
    <nav
      className="flex gap-1 overflow-x-auto border-b border-gray-200 pb-px"
      aria-label="Channel partner sections"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={`whitespace-nowrap rounded-t-lg px-4 py-2.5 text-sm font-medium transition-colors ${
            activeTab === tab.id
              ? 'border-b-2 border-[var(--primary)] text-[var(--primary)] bg-[var(--primary)]/5'
              : 'text-gray-500 hover:text-gray-800 hover:bg-gray-50'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
};

export function parsePartnerDetailTab(value: string | null): PartnerDetailTab {
  const valid: PartnerDetailTab[] = [
    'overview', 'compliance', 'users', 'fees', 'portal', 'operations',
  ];
  if (value && valid.includes(value as PartnerDetailTab)) {
    return value as PartnerDetailTab;
  }
  return 'overview';
}
